export const baseURL = "https://api.countermachine.in/Merchant/api/";
